export const PHOTOGRAPHER_PACKAGE_LIST_VISIBLE_CATEGORY_PACKAGE = 'PHOTOGRAPHER_PACKAGE_LIST_VISIBLE_CATEGORY_PACKAGE';



// WEBPACK FOOTER //
// ./engines/vcliq_booking/app/assets/javascripts/vcliq_booking/components/photographerPackageList/events.js